var QueueSamplingController = (function () {
    function QueueSamplingController($scope, env, $filter, $timeout, $q, socket, DTS, DTOptionsBuilder, DTColumnBuilder, _, $compile, $state, $stateParams, notify, Dialog, settings, $mdDialog) {
        var _this = this;
        this.$scope = $scope;
        this.env = env;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.DTS = DTS;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this._ = _;
        this.$compile = $compile;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.notify = notify;
        this.Dialog = Dialog;
        this.settings = settings;
        this.$mdDialog = $mdDialog;
        this.showFilterBtn = false;
        this.filterIots = [];
        this.goeFilter = false;
        this.verFilter = undefined;
        this.solDecFilter = 'all';
        this.filterImts = [];
        this.filterComboList = [];
        this.filterCurrCombo = [];
        this.filterCountries = [];
        this.selectedStates = [];
        this.USstates = [];
        this.filterSolutionSamplStatus = [];
        this.filterSSASamplStatus = [];
        this.filters = {
            USstates: [],
            countries: [],
            imts: [],
            iots: [],
            samplingStatus: []
        };
        this.sampReason = '';
        this.reportIsBeingBuilt = false;
        this.isFilterToggled = false;
        this.addSampArray = [];
        this.statusChange = '';
        this.dtInstance = {};
        this.queryId = this.$stateParams.id;
        this.deferred = this.$q.defer();
        this.enableButtons = false;
        this.socket.forward('sampling.additional.list', this.$scope);
        this.$scope.$on('socket:sampling.additional.list', function (event, data) {
            _this.isSubmitting = true;
            _this.addSampArray = data;
            _this.filterArray = _this.addSampArray.slice();
            _this.resetFilterLists();
            _this.filterCurrCombo = _this.filterComboList.slice();
            _this.queueDetails(event, _this.filterArray);
            _this.enableButtons = true;
        });
        this.socket.forward('queue.sampling.createSamplingExcel', this.$scope);
        this.$scope.$on('socket:queue.sampling.createSamplingExcel', function (event, data) {
            _this.reportIsBeingBuilt = false;
            if (!data.payload.error) {
                var a = document.createElement('A');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none;');
                var url = window.URL.createObjectURL(new Blob([data.payload], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }));
                a.setAttribute('href', url);
                var d = new Date().toDateString();
                a.setAttribute('download', "DMT-Sampling-Report_" + d + ".xlsx");
                a.click();
            }
        });
        this.socket.forward('addsampling.done', this.$scope);
        this.$scope.$on('socket:addsampling.done', function (event, data) {
            for (var i = 0; i < _this.addSampArray.length; i++) {
                if (_this.addSampArray[i].opp === _this.currOppty) {
                    _this.addSampArray[i].samplingStatus = _this.statusChange;
                    break;
                }
            }
            for (var i = 0; i < _this.filterArray.length; i++) {
                if (_this.filterArray[i].opp === _this.currOppty) {
                    _this.filterArray[i].samplingStatus = _this.statusChange;
                    break;
                }
            }
            _this.dtInstance.changeData(function () {
                return _this.getData(null);
            });
            _this.dtInstance.reload();
            _this.queueDetails(event, _this.filterArray);
            if (data.success === true) {
                _this.enableButtons = true;
            }
        });
    }
    QueueSamplingController.prototype.$onInit = function () {
        this.loadInitialSamplingData();
    };
    QueueSamplingController.prototype.loadInitialSamplingData = function () {
        this.samplingPage = true;
        this.queueLabel = 'Sampling Queue';
        this.filterToggles = {
            countries: true,
            goe: true,
            imts: true,
            sampStat: true,
            solutionDecision: true
        };
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                email: this.env.user.email,
                function: 'getPotentialSampling',
                script: 'queue/queue',
                token: this.env.user.token
            }
        });
        this.isSubmitting = false;
        this.dtColumns = this.buildColumns();
        this.buildOptions();
    };
    QueueSamplingController.prototype.buildOptions = function () {
        var _this = this;
        var that = this;
        this.dtOptions = {};
        this.dtOptions = this.DTOptionsBuilder
            .fromFnPromise(function () {
            return _this.getData(null);
        })
            .withPaginationType('full_numbers')
            .withOption('processing', true)
            .withOption('createdRow', createdRow);
        function createdRow(row, data, dataIndex) {
            var OFFSET = 3;
            var thresholdDate = new Date();
            thresholdDate.setHours(0, 0, 0, 0);
            thresholdDate.setDate(thresholdDate.getDate() - OFFSET);
            var createdOn = new Date(parseInt(data.created));
            createdOn.setHours(0, 0, 0, 0);
            if (createdOn <= thresholdDate && data.substatus === 'Unassigned') {
                $(row).addClass('tblRow').css('background-color', '#ff5252');
            }
            else {
                $(row).addClass('tblRow');
            }
            var el = angular.element;
            that.$compile(el(row).contents())(that.$scope);
        }
    };
    QueueSamplingController.prototype.buildColumns = function () {
        return [
            this.DTColumnBuilder.newColumn('ver').withTitle('Version').withOption('name', 'ver')
                .renderWith(this.getVersionLabel)
                .notSortable(),
            this.DTColumnBuilder.newColumn('opp')
                .withTitle('Opp Number')
                .renderWith(this.linkUrl),
            this.DTColumnBuilder.newColumn('country').withOption('name', 'country')
                .withTitle('Country'),
            this.DTColumnBuilder.newColumn('goe').withOption('name', 'goe')
                .withTitle('GE Flag'),
            this.DTColumnBuilder.newColumn('bp_name')
                .withTitle('BP'),
            this.DTColumnBuilder.newColumn('acctname')
                .withTitle('Account'),
            this.DTColumnBuilder.newColumn('status')
                .withTitle('Status'),
            this.DTColumnBuilder.newColumn('sub_status')
                .withTitle('Sub-status'),
            this.DTColumnBuilder.newColumn('samplingStatus_ssa').withOption('name', 'samplingStatus_ssa')
                .withTitle('SSA Sampling Status'),
            this.DTColumnBuilder.newColumn('samplingStartDate_ssa').withOption('name', 'samplingStartDate_ssa')
                .withTitle('SSA Sampling Start Date'),
            this.DTColumnBuilder.newColumn('samplingStatus_solution').withOption('name', 'samplingStatus_solution')
                .withTitle('Solution Sampling Status'),
            this.DTColumnBuilder.newColumn('samplingStartDate_solution')
                .withTitle('Solution Sampling Start Date'),
            this.DTColumnBuilder.newColumn('aging')
                .withTitle('Aging'),
            this.DTColumnBuilder.newColumn('soNumber')
                .withTitle('SO Number'),
            this.DTColumnBuilder.newColumn('soDate')
                .withTitle('SO Date'),
            this.DTColumnBuilder.newColumn('solutionDecision').withOption('name', 'solutionDecision')
                .withTitle('SSA/Solution flag'),
            this.DTColumnBuilder.newColumn('state').withOption('name', 'state')
                .withTitle('State')
                .renderWith(this.showState),
        ];
    };
    QueueSamplingController.prototype.linkUrl = function (data, type, full, meta) {
        return "<a class='ibm-ind-link' href='detail/" + data + "/sampling' ng-click='$event.preventDefault();vm.sampEdit(\"" + data + "\")'>" + data + "</a>";
    };
    QueueSamplingController.prototype.showState = function (data, type, full, meta) {
        if (full.country === 'USA') {
            return "<p>" + data + "<p>";
        }
        else {
            return "<p> -- <p>";
        }
    };
    QueueSamplingController.prototype.linkButton = function (data, type, full, meta) {
        switch (full.samplingStatus) {
            case 'untested':
            case 'Manual override':
                return '<md-button class="ibm-btn-pri ibm-btn-small ibm-btn-green-50" ng-click="vm.sampActivate(' + meta.row + ')" ng-disabled="(!vm.enableButtons)">Activate</md-button>'; //' + meta.row + '
            case 'Manually sampled - In Progress':
                return '<md-button class="ibm-btn-pri ibm-btn-small ibm-btn-red-50" ng-click="vm.sampDeactivate(' + meta.row + ')" ng-disabled="(!vm.enableButtons)">Deactivate</md-button>';
            default:
                return '<p></p>';
        }
    };
    QueueSamplingController.prototype.downloadSamplingReport = function () {
        this.reportIsBeingBuilt = true;
        var filters = {
            filterCountries: this.filterCountries,
            filterImts: this.filterImts,
            filterIots: this.filterIots,
            goeFilter: this.goeFilter,
            verFilter: this.verFilter,
            filterSolutionSamplStatus: this.filterSolutionSamplStatus,
            filterSSASamplStatus: this.filterSSASamplStatus,
            selectedStates: this.selectedStates
        };
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                email: this.env.user.email,
                function: 'downloadSampling',
                script: 'sampling/downloadSampling',
                filters: filters,
                token: this.env.user.token
            }
        });
    };
    QueueSamplingController.prototype.sampManipulate = function (oppty) {
        this.enableButtons = false;
        var rowData = this.dtInstance.DataTable.row(oppty).data();
        this.currOppty = rowData.opp;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    cty: rowData.country,
                    goe: rowData.goe,
                    initBy: this.env.user.email,
                    opp: rowData.opp,
                    program: this.topic.topic.program,
                    sampComment: {
                        comment: rowData.samplingStatus + " changed to " + this.statusChange,
                        source: this.env.user.email,
                        time: (new Date()).getTime()
                    },
                    sampReason: this.sampReason,
                    status: this.statusChange,
                    timestamp: (new Date()).getTime()
                },
                email: this.env.user.email,
                token: this.env.user.token,
                function: 'addActivateSampling',
                script: 'queue/queue'
            }
        });
    };
    QueueSamplingController.prototype.sampEdit = function (index) {
        this.$state.go('detail.sampling', {
            id: index
        });
    };
    // getting the data
    QueueSamplingController.prototype.getData = function (args) {
        return this.deferred.promise;
    };
    // manipulating the data
    QueueSamplingController.prototype.queueDetails = function (ev, data) {
        this.deferred.resolve(data);
    };
    QueueSamplingController.prototype.toggleFilter = function () {
        this.isFilterToggled = !this.isFilterToggled;
    };
    QueueSamplingController.prototype.applysolDecFilter = function (el) {
        if (el === 'Solution' || el === 'SSA') {
            this.dtInstance.DataTable.column('solutionDecision:name').search(el, true, false).draw();
        }
        else {
            this.loadInitialSamplingData();
        }
    };
    QueueSamplingController.prototype.applyFilter = function () {
        var _this = this;
        //TODO - double check it
        this.addSampArray = this.addSampArray.filter(function (sampElem) { return sampElem.samplingStatus; });
        var filterList = {
            iot: this.filterIots,
            imt: this.filterImts,
            country: this.filterCountries,
            state: this.selectedStates
        };
        var samplingFilterKeys = [];
        _.forEach(filterList, function (selectedFilters, key) {
            if (selectedFilters.length > 0) {
                _this.filterArray = [];
                samplingFilterKeys.push(key);
                selectedFilters.forEach(function (filter) {
                    _this.filterArray = _this.filterArray.concat(_this.addSampArray.filter(function (sampElem) { return sampElem[key] === filter; }));
                });
            }
        });
        this.isFilterSet = (samplingFilterKeys.length > 0 || this.goeFilter || typeof this.verFilter !== 'undefined');
        if (this.isFilterSet) {
            this.filterArray = this.addSampArray.slice();
        }
        //Ver filter
        this.dtInstance.DataTable.column('ver:name').search(this.getVersionLabel(this.verFilter), true, false).draw();
        // GOE filter
        this.dtInstance.DataTable.column('goe:name').search((this.goeFilter ? 'Yes' : ''), true, false).draw();
        // Solution Sampling Status filter
        var solStFltr = this.filterSolutionSamplStatus;
        var solStFltrRegeXp = (Array.isArray(solStFltr) && solStFltr.length > 0) ? solStFltr.join('|') : '';
        this.dtInstance.DataTable.column('samplingStatus_solution:name').search(solStFltrRegeXp, true, false).draw();
        // SSA Sampling Status filter
        var ssaStFltr = this.filterSSASamplStatus;
        var ssaStFltrRegExp = (Array.isArray(ssaStFltr) && ssaStFltr.length > 0) ? ssaStFltr.join('|') : '';
        this.dtInstance.DataTable.column('samplingStatus_ssa:name').search(ssaStFltrRegExp, true, false).draw();
        // IOT, IMT and Country filters
        var samplingFilterResult = [];
        //GEO keys - the order is important
        var orderedGeoKeys = ['iot', 'imt', 'country'];
        this.filterArray.forEach(function (elem) {
            if (samplingFilterKeys.includes('state')) {
                if (!samplingFilterResult.includes(elem.state)) {
                    samplingFilterResult.push(elem.state);
                }
            }
            else if (orderedGeoKeys.some(function (filter) { return samplingFilterKeys.includes(filter); })) {
                //process the smallest geo filter only
                var smallestGeoKey_1 = orderedGeoKeys.filter(function (geo) { return samplingFilterKeys.indexOf(geo) !== -1; }).pop();
                if (smallestGeoKey_1) {
                    //samplingFilterKeys.forEach((key) => {
                    if (elem[smallestGeoKey_1] && filterList[smallestGeoKey_1] && filterList[smallestGeoKey_1].filter(function (it) { return it === elem[smallestGeoKey_1]; }).length > 0) {
                        if (!samplingFilterResult.includes(elem.country)) {
                            samplingFilterResult.push(elem.country);
                        }
                    }
                }
            }
        });
        var tableSearchRegExp = (samplingFilterResult.length > 0) ? samplingFilterResult.join('|') : '';
        this.dtInstance.DataTable.search(tableSearchRegExp, true, false).draw();
        // State filter
        var stateRegExp = samplingFilterKeys.includes('state') ? samplingFilterResult.join('|') : '';
        this.dtInstance.DataTable.column('state:name').search(stateRegExp, true, false).draw();
    };
    QueueSamplingController.prototype.resetFilterLists = function () {
        for (var i = 0; i < this.addSampArray.length; i++) {
            if (this.filters.iots.indexOf(this.addSampArray[i].iot) < 0) {
                this.filters.iots.push(this.addSampArray[i].iot);
            }
            if (this.filters.imts.indexOf(this.addSampArray[i].imt) < 0) {
                this.filters.imts.push(this.addSampArray[i].imt);
            }
            if (this.filters.countries.indexOf(this.addSampArray[i].country) < 0) {
                this.filters.countries.push(this.addSampArray[i].country);
                var listItem = {
                    goe: this.addSampArray[i].goe,
                    imt: this.addSampArray[i].imt,
                    country: this.addSampArray[i].country,
                    state: this.addSampArray[i].country
                };
                this.filterComboList.push(listItem);
            }
            if (this.addSampArray[i].country === 'USA' && this.USstates.indexOf(this.addSampArray[i].state) < 0) {
                this.USstates.push(this.addSampArray[i].state);
            }
            this.filters.samplingStatus = [
                'Manually sampled - Failed',
                'Manually sampled - Passed',
                'Manual override',
                'Passed',
                'Failed',
                'In progress'
            ];
        }
        this.filters.imts.sort();
        this.filters.countries.sort();
        this.filters.iots.sort();
    };
    QueueSamplingController.prototype.clearFilter = function () {
        this.isFilterSet = false;
        this.goeFilter = false;
        this.filterImts = [];
        this.filterIots = [];
        this.filterCountries = [];
        this.filterSolutionSamplStatus = [];
        this.filterSSASamplStatus = [];
        this.resetFilterLists();
        this.loadInitialSamplingData();
    };
    QueueSamplingController.prototype.changeFilters = function (id) {
        var _this = this;
        if (id === 'goeFilter') {
            this.showFilterBtn = true;
        }
        if (id === 'goe') {
            this.filterImts = [];
            this.filterCountries = [];
            this.filters.imts = [];
            this.filters.countries = [];
            if (this.filterIots.length === 0) {
                for (var i = 0; i < this.filterComboList.length; i++) {
                    if (this.filters.imts.indexOf(this.filterComboList[i].imt) < 0) {
                        this.filters.imts.push(this.filterComboList[i].imt);
                    }
                    if (this.filters.countries.indexOf(this.filterComboList[i].country) < 0) {
                        this.filters.countries.push(this.filterComboList[i].country);
                    }
                }
            }
            else {
                for (var i = 0; i < this.filterComboList.length; i++) {
                    if (this.filterIots.indexOf(this.filterComboList[i].goe) > -1 && this.filters.imts.indexOf(this.filterComboList[i].imt) < 0) {
                        this.filters.imts.push(this.filterComboList[i].imt);
                    }
                    if (this.filterIots.indexOf(this.filterComboList[i].goe) > -1 && this.filters.countries.indexOf(this.filterComboList[i].country) < 0) {
                        this.filters.countries.push(this.filterComboList[i].country);
                    }
                }
            }
        }
        else if (id === 'imt') {
            this.filterCountries = [];
            this.filters.countries = [];
            if (this.filterImts.length === 0) {
                for (var i = 0; i < this.filterComboList.length; i++) {
                    if (this.filters.countries.indexOf(this.filterComboList[i].country) < 0) {
                        this.filters.countries.push(this.filterComboList[i].country);
                    }
                }
            }
            else {
                for (var i = 0; i < this.filterComboList.length; i++) {
                    if (this.filterImts.indexOf(this.filterComboList[i].imt) > -1 && this.filters.countries.indexOf(this.filterComboList[i].country) < 0) {
                        this.filters.countries.push(this.filterComboList[i].country);
                    }
                }
            }
        }
        else if (id === 'iot') {
            this.filterImts = [];
            this.filterCountries = [];
            this.filters.imts = [];
            this.filters.countries = [];
            if (this.filterIots.length > 0) {
                this.settings.country_list.forEach(function (value) {
                    if (value.ic === 'IMT') {
                        if (_.includes(_this.filterIots, value.imt) &&
                            !_.includes(_this.filters.imts, value.imt_name)) {
                            _this.filters.imts.push(value.imt_name);
                        }
                    }
                    else if (value.ic === 'Country') {
                        if (_.includes(_this.filterIots, value.imt) &&
                            !_.includes(_this.filters.countries, value.country)) {
                            _this.filters.countries.push(value.country);
                        }
                    }
                });
            }
            else {
                this.settings.country_list.forEach(function (value) {
                    if (value.ic === 'IMT') {
                        _this.filters.imts.push(value.imt_name);
                    }
                    else if (value.ic === 'Country') {
                        _this.filters.countries.push(value.country);
                    }
                });
            }
        }
        this.showFilterBtn = true;
    };
    QueueSamplingController.prototype.getVersionLabel = function (ver) {
        switch (ver) {
            case 0:
                return 'CVR|SWDR';
            case 1:
            case 2:
                return 'CVR';
            case 3:
                return 'SWDR';
            default:
                return '';
        }
    };
    QueueSamplingController.$inject = ['$scope', 'env', '$filter', '$timeout', '$q', 'socket',
        'DTS', 'DTOptionsBuilder', 'DTColumnBuilder', '_',
        '$compile', '$state', '$stateParams', 'notify', 'Dialog', 'settings', '$mdDialog', 'topic'];
    return QueueSamplingController;
}());
var QueueSamplingComponent = (function () {
    function QueueSamplingComponent() {
        this.templateUrl = 'queueSampling.html';
        this.controllerAs = 'vm';
        this.controller = QueueSamplingController;
    }
    return QueueSamplingComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('clearAll', '/public/icons/ic_clear_all_black_18px.svg');
})
    .component('queueSamplingSection', new QueueSamplingComponent());

//# sourceMappingURL=queue.sampling.component.js.map
